export default __webpack_public_path__ + "97e5c9b49cae32034d91b8e54cf443e4.png";